export const agentRouteConfig = {
  "/agent/dashboard": {
    pageTitle: "Agent Dashboard",
    breadcrumbs: [
      { label: "Dashboard", url: "/agent/dashboard" }
    ],
  },
  "/agent/students": {
    pageTitle: "Students",
    breadcrumbs: [
      { label: "Dashboard", url: "/agent/dashboard" },
      { label: "Students", url: "/agent/students" }
    ],
  },
  "/agent/commissions": {
    pageTitle: "Commissions",
    breadcrumbs: [
      { label: "Dashboard", url: "/agent/dashboard" },
      { label: "Commissions", url: "/agent/commissions" }
    ],
  },
  "/agent/profile": {
    pageTitle: "Profile",
    breadcrumbs: [
      { label: "Dashboard", url: "/agent/dashboard" },
      { label: "Profile", url: "/agent/profile" }
    ],
  },
};
